import { css } from "@web/helpers/webComponents";

const styles: string = css`
    :host {
        position: absolute;
        right: 1rem;
        top: 5rem;
    }

    button {
        background: none;
        border: none;
    }

    dialog {
        background-color: var(--footer-background-color);
        border: none;
        color: var(--color-white);
        padding: 5rem 3rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 5rem;
    }

    dialog a {
        background-color: var(--button-background-color);
        color: var(--button-color);
        padding: 5px 10px;
        margin: 0 0 10px 10px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
        text-decoration: none;

        transition: opacity var(--button-hover-transition-duration) ease-out;
    }

    a:hover {
        opacity: 0.8;
    }

    dialog::backdrop {
        background-color: rgba(0, 0, 0, 0.5);
    }

`;

/**
 * A home button and a confirmation dialog
 */
class HomeButtonComponent extends HTMLElement {
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
<button command="show-modal" commandfor="goHome" href="/">
    <svg fill="#737373" width="50px" height="50px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 16h4l12-13.696 12 13.696h4l-13.984-16h-4zM4 32h8v-9.984q0-0.832 0.576-1.408t1.44-0.608h4q0.8 0 1.408 0.608t0.576 1.408v9.984h8v-13.408l-12-13.248-12 13.248v13.408zM26.016 6.112l4 4.576v-8.672h-4v4.096z"></path>
</button>
<dialog closedby="any" id="goHome">
    Are you sure you want to go to the home?
    <a href="endscreen.html">
    Go Home 
    </a>
</dialog>


        `;
    }
}

customElements.define("home-button", HomeButtonComponent);
